import StatGrid from '@commons/stats'
const Stats = () => {
  const items: any = [
    {
      title: 'Total Earning',
      value: 'Rs.155',
      icon: 'money',
      bg: 'secondary50',
    },
    {
      title: 'Current Balance',
      value: 'Rs.30,000',
      icon: 'money',
      bg: 'danger50',
    },
    {
      title: 'Total Withdrawal',
      value: 'Rs.23000',
      icon: 'withdraw',
      bg: 'green100',
    },
    {
      title: 'Total Appointment',
      value: '23',
      icon: 'appointment',
      bg: 'yellow100',
    },
    {
      title: 'Patient This Month',
      value: '23',
      icon: 'users',
      bg: 'yellow150',
    },
    {
      title: 'Online Consultation',
      value: '23',
      icon: 'appointment',
      bg: 'orange100',
    },
  ]
  return <StatGrid items={items} />
}

export default Stats
